var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.states,
      attrs: { "data-component": "base-search-input" },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.onFocus.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "form",
        {
          attrs: { "data-form": "search" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onSearchSubmit.apply(null, arguments)
            },
            click: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c("base-search-query", {
            attrs: { query: _vm.query, schema: _vm.schema },
            on: { "delete-param": _vm.onDeleteParam },
            scopedSlots: _vm._u([
              {
                key: "input",
                fn: function () {
                  return [
                    _c("base-search-input-wrapper", {
                      attrs: {
                        query: _vm.query,
                        schema: _vm.schema,
                        search: _vm.search,
                        "is-in-focus": _vm.isInFocus,
                        "is-options-popup-open": _vm.isOptionsPopupOpen,
                      },
                      on: {
                        "search-change": function ($event) {
                          _vm.search = $event
                        },
                        "query-change": function ($event) {
                          return _vm.$emit("query-change", $event)
                        },
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: { "is-clickable": _vm.icon === "clear" },
          attrs: { "data-button": "clear-query" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.onClearQuery.apply(null, arguments)
            },
          },
        },
        [_c("or-icon", { attrs: { icon: _vm.icon } })],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }